export default "__VITE_ASSET__Bkqcf0g$__"